<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close(formRef)"
    >
      <el-form ref="formRef" label-width="120px" :model="form" :rules="rules">
        <!-- 门店 -->
        <el-form-item label="门店" prop="branchId">
          <el-select
            v-model="form.branchId"
            placeholder="请选择门店"
            class="fix-width"
            clearable
            :disabled="!!form.hotelId"
          >
            <el-option
              v-for="item in branchList"
              :key="item.branchId"
              :label="item.title"
              :value="item.branchId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="上架状态">
          <el-radio-group v-model="form.step" size="mini">
            <el-radio-button :label="1">未上架</el-radio-button>
            <el-radio-button :label="2">上架</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="封面" prop="avatar">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <img v-if="form.avatar" :src="form.avatar" class="avatar" />
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
          <span>建议尺寸：750px * 360px</span>
        </el-form-item>
        <el-form-item label="轮播图" prop="imageList">
          <el-upload
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="form.imageList"
            :on-success="imageList_success"
            :on-remove="imageList_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input
            v-model.trim="form.address"
            class="fix-width"
            placeholder="请输入地址"
          />
        </el-form-item>
        <el-form-item label="经度" prop="lat">
          <el-input
            v-model.trim="form.lat"
            class="fix-width"
            placeholder="请输入经度"
          />
        </el-form-item>
        <el-form-item label="维度" prop="lng">
          <el-input
            v-model.trim="form.lng"
            class="fix-width"
            placeholder="请输入维度"
          />
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input
            v-model.trim="form.tel"
            class="fix-width"
            placeholder="请输入联系电话"
          />
        </el-form-item>
        <el-form-item label="开业日期" prop="openDate">
          <el-date-picker
            v-model="form.openDate"
            type="date"
            value-format="YYYY-MM-DD"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="标签" prop="tag">
          <el-select
            v-model="form.tagList"
            multiple
            allow-create
            filterable
            default-first-option
            placeholder="请选择或填写标签"
            class="fix-width"
          >
            <el-option
              v-for="item in apartmentTags"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="酒店政策">
          <el-row
            gutter="20"
            align="middle"
            v-for="(item, index) of form.tipList"
            :key="index"
          >
            <el-col :span="8">
              <el-input v-model="item.title" placeholder="标题" />
            </el-col>
            <el-col :span="8">
              <el-input
                v-model="item.text"
                type="textarea"
                placeholder="请输入内容"
              />
            </el-col>
            <el-col :span="8">
              <el-button type="primary" @click="addTip">添加</el-button>
              <el-button v-if="index != 0" type="danger" @click="delTip(index)">
                删除
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="酒店设施">
          <el-row
            gutter="20"
            align="middle"
            v-for="(item, index) of form.facilityList"
            :key="index"
          >
            <el-col :span="8">
              <el-upload
                class="avatar-uploader"
                :show-file-list="false"
                :action="QNUploadURL"
                :data="uploadToken"
                :on-success="
                  function (res, file, fileList) {
                    return handleImgSuccess(index, res, file, fileList)
                  }
                "
                :on-remove="
                  function (file, fileList) {
                    return handleImgRemove(index, file, fileList)
                  }
                "
              >
                <img v-if="item.icon" :src="item.icon" class="icon_avatar" />
                <i v-else class="avatar-uploader-icon-small el-icon-plus"></i>
              </el-upload>
              <span>建议尺寸：64px * 64px</span>
            </el-col>
            <el-col :span="8">
              <el-input v-model="item.title" placeholder="标题" />
            </el-col>
            <el-col :span="8">
              <el-button type="primary" @click="addFac">添加</el-button>
              <el-button v-if="index != 0" type="danger" @click="delFac(index)">
                删除
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="简介文字" prop="desc">
          <el-input
            v-model="form.desc"
            type="textarea"
            class="fix-width"
            placeholder="请输入简介文字"
          />
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close(formRef)">取 消</el-button>
        <el-button type="primary" @click="save(formRef)">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createHotel, updateHotel } from '@/api/room'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
import { getAllBranchs } from '@/api/branch'
import { ref, reactive, getCurrentInstance } from 'vue'
export default {
  name: 'HotelEdit',
  emits: ['fetch-data'],
  setup(_, { emit }) {
    const { proxy } = getCurrentInstance()
    const title = ref('')
    const uploadToken = reactive({
      token: '',
    })
    const branchList = reactive([])
    const dialogFormVisible = ref(false)
    const formRef = ref(null)
    const initForm = () => {
      return {
        hotelId: '',
        title: '',
        branchId: '',
        avatar: '',
        imageList: [],
        text: '',
        address: '',
        lat: '',
        lng: '',
        tel: '',
        openDate: '',
        desc: '',
        tagList: [],
        tipList: [{ title: '', text: '' }],
        facilityList: [{ icon: '', title: '' }],
        step: 2,
        order: 1,
      }
    }
    const apartmentTags = ['经济型', '快捷酒店']
    const form = reactive(initForm())
    const rules = {
      title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
      branchId: [{ required: true, trigger: 'blur', message: '请选择门店' }],
      avatar: [
        {
          required: true,
          validator: (_, value, callback) => {
            if (value.length == 0) {
              callback(new Error('请上传封面'))
            } else {
              callback()
            }
          },
        },
      ],
    }
    const getAllBranchList = async () => {
      const res = await getAllBranchs({})
      if (!res) return
      branchList.length = 0
      branchList.push(...res)
    }
    const showEdit = async (row) => {
      if (row && row.hotelId) {
        title.value = '修改酒店'
        Object.assign(form, row.basic)
        form.hotelId = row.hotelId
        form.title = row.title
        form.step = row.step
        form.branchId = row.extra.branchId
      } else {
        title.value = '新增酒店'
      }
      getAllBranchList()
      dialogFormVisible.value = true
      const token = await getUploadToken({})
      uploadToken.token = token.token
    }
    const formReset = (formRef) => {
      if (!formRef) return
      formRef.resetFields()
      Object.assign(form, initForm())
    }
    const close = (formRef) => {
      formReset(formRef)
      dialogFormVisible.value = false
    }
    //隐私内容
    const addTip = () => {
      form.tipList.push({ title: '', text: '' })
    }
    const delTip = (index) => {
      form.tipList.splice(index, 1)
    }
    //设施
    const addFac = () => {
      form.facilityList.push({ icon: '', title: '' })
    }
    const delFac = (index) => {
      form.facilityList.splice(index, 1)
    }
    //设施图片
    const handleImgSuccess = (index, res, file, fileList) => {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      form.facilityList[index].icon = QNHost + '/' + res.hash
    }
    const handleImgRemove = (index, file, fileList) => {
      form.facilityList[index].icon = ''
    }
    // 图片
    const imageList_remove = (_, fileList) => {
      form.imageList = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    }
    const image_remove = () => {
      form.avatar = ''
    }
    const image_success = (res, _) => {
      if (!res.hash) {
        proxy.$message.error('图片上传失败')
        return
      }
      form.avatar = `${QNHost}/${res.hash}`
    }
    const imageList_success = (res, file) => {
      if (!res.hash) {
        proxy.$message.error('图片上传失败')
        return
      }
      form.imageList.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    }
    const save = (formRef) => {
      if (!formRef) return
      formRef.validate(async (valid) => {
        if (valid) {
          const hotelId = form.hotelId
          const data = Object.assign({}, form)
          proxy.$baseConfirm(
            `你确定要${hotelId ? '修改' : '新增'}酒店吗`,
            null,
            async () => {
              hotelId ? await updateHotel(data) : await createHotel(data)
              proxy.$baseMessage(
                `${hotelId ? '修改' : '新增'}酒店成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              emit('fetch-data')
              close(formRef)
            }
          )
        } else {
          return false
        }
      })
    }
    //暴露子组件方法
    // defineExpose({
    //   showEdit,
    // })
    return {
      title,
      QNUploadURL,
      QNHost,
      uploadToken,
      branchList,
      formRef,
      form,
      rules,
      apartmentTags,
      dialogFormVisible,
      showEdit,
      getAllBranchList,
      close,
      addTip,
      delTip,
      addFac,
      delFac,
      imageList_remove,
      image_remove,
      image_success,
      handleImgSuccess,
      handleImgRemove,
      imageList_success,
      save,
    }
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 80px;
  height: 80px;
  border-radius: 6px;
  transition: all 0.3s ease-in-out;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.avatar-uploader-icon-small {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}

.mr-10 {
  margin-right: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
